import BeneficiaryForm from './BeneficiaryFormContainer';

export default BeneficiaryForm;
